import { TribesHandler } from '../tribes_handler'

export const tribesHandler = new TribesHandler()
